import { Injectable } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';
import { OnExecuteErrorData, ReCaptchaV3Service } from 'ng-recaptcha';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  private errorSubscription: Subscription;

  constructor(
    private reCaptchaV3Service: ReCaptchaV3Service
    ) { }

  public async execute(actionName: string) {

    if(!this.errorSubscription){
      this.errorSubscription = this.reCaptchaV3Service.onExecuteError.subscribe(
        (error: OnExecuteErrorData) =>{
          console.error('Erro no serviço reCaptcha: ' + error.action);
          console.error(error.error);
        }
      );
    }


    const token = await lastValueFrom(this.reCaptchaV3Service.execute(actionName));

    return token;
  }
}
